exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cortar{\n    \n    /* border:1px solid blue; */\n    text-overflow:ellipsis !important;\n    white-space:nowrap !important; \n    overflow:hidden !important; \n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/modals/plan-cuentas-add-modal/plan-cuentas-add-modal.component.css
// module id = ../../../../../src/app/components/modals/plan-cuentas-add-modal/plan-cuentas-add-modal.component.css
// module chunks = main